import React from "react"
import { Container } from "reactstrap"
import awicon from "assets/images/services-icon/coin.png"

type HeaderProp = {
  title: React.ReactElement | string | undefined;
  subjectId?: number;
  activityTypeName: string;
  coinsEarned?: number;
  coinsPossible?: number;
}

export const Header =
  (props: HeaderProp) => {

    const { title, subjectId, activityTypeName } = props

    let subjectName = ""
    switch (subjectId) {
      case 1:
        subjectName = "English"
      case 2:
        subjectName = "Mathematics"
    }

    return (
      <Container className="custom-wt">
        <div className="d-flex align-items-center">
          <div className="mt-0 border-right me-4" style={{ width: "20%" }}>
            <div
              className="font-size-14 text-uppercase cursor-pointer"
              onClick={() => history.back()}
            >
              {" "}
              <span><i className=" fas fa-chevron-left me-1"></i></span>
              {" "}
              Back
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-between flex-grow-1">
            <h6 className="mb-0 font-size-20 w-60 fw-regular">
              {title}
            </h6>
            <p className="mb-0 text-uppercase">
              {" "}
              <span className="me-1">
              {subjectName}
            </span>{" "}
              {activityTypeName}
              {" "}
            </p>

            <div className="font-size-16">
              <img width={24} className="" src={awicon} alt="" /> {props.coinsEarned ?? 0}/{props.coinsPossible ?? 0}{" "}
              coins earned
            </div>

          </div>
        </div>
      </Container>

    )
  }
